/* esm.sh - unhead@3.1.0/dist/shared/unhead.CUXLLRtV */
function n(e){return e}export{n as d};
//# sourceMappingURL=unhead.CUXLLRtV.mjs.map